<div class="overflow-auto mt-4 px-5 pb-6">
    @if (error()) {
        <kno2-notification-alert
            type="danger"
            [title]="error()"
            [messages]="errorMessages()"
            (dismiss)="error.set(''); errorMessages.set([])" />
    }

    <div class="form-group row">
        <label
            for="name"
            class="col-sm-3 control-label text-end col-form-label">
            Name
        </label>
        <div class="col-sm-7">
            <kno2-form-input
                #nameInput
                name="name"
                placeholder="Name"
                [maxlength]="255"
                [control]="form.controls.name"
                [hasError]="form.controls.name.invalid && form.controls.name.touched"
                [mask]="'A*'"
                [maskPattern]="namePattern"
                [showMaskTyped]="false"
                errorClass="is-invalid" />
            <kno2-form-input-error
                [control]="form.controls.name"
                [showErrorOn]="'touched'" />
        </div>
        @if (isAsyncValidatorRunning()) {
            <div class="d-flex align-items-center">
                <span class="spinner-border spinner-border-sm"></span>
            </div>
        }
    </div>

    <div class="form-group row">
        <label
            for="description"
            class="col-sm-3 control-label text-end col-form-label">
            Description
        </label>
        <div class="col-sm-7">
            <kno2-form-input
                name="description"
                placeholder="Description"
                [maxlength]="255"
                [control]="form.controls.description"
                [hasError]="form.controls.description.invalid && form.controls.description.touched"
                errorClass="is-invalid" />
            <kno2-form-input-error
                [control]="form.controls.description"
                [showErrorOn]="'touched'" />
        </div>
    </div>

    <div class="form-group row">
        <label
            for="category"
            class="col-sm-3 control-label text-end col-form-label">
            Category
        </label>
        <div class="col-sm-7">
            <kno2-form-radio-input
                name="category"
                [control]="form.controls.category"
                [options]="categoryOptions" />
            <kno2-form-input-error
                [control]="form.controls.category"
                [showErrorOn]="'touched'" />
        </div>
    </div>

    <div class="form-group row">
        <label
            for="subscriptionId"
            class="col-sm-3 control-label text-end col-form-label">
            Subscription
        </label>
        <div class="col-sm-7">
            <kno2-form-select
                placeholder="None"
                [control]="form.controls.subscriptionId"
                [options]="subscriptionPlanOptions()"
                [hasError]="form.controls.subscriptionId.invalid && form.controls.subscriptionId.touched" />
            <kno2-form-input-error
                [control]="form.controls.subscriptionId"
                [showErrorOn]="'touched'" />
        </div>
    </div>

    @if (form.controls.subscriptionId.value) {
        <div class="form-group row">
            <label
                for="subscriptionDurationDays"
                class="col-sm-3 control-label text-end col-form-label">
                Subscription Duration (Days)
            </label>
            <div class="col-sm-7">
                <kno2-form-input
                    name="subscriptionDurationDays"
                    placeholder="Duration in days"
                    [maxlength]="3"
                    [control]="form.controls.subscriptionDurationDays"
                    [mask]="'000'"
                    [hasError]="form.controls.subscriptionDurationDays.invalid && form.controls.subscriptionDurationDays.touched"
                    errorClass="is-invalid" />
                <kno2-form-input-error
                    [control]="form.controls.subscriptionDurationDays"
                    [showErrorOn]="'touched'" />
            </div>
        </div>
    }
</div>

<div class="modal-footer modal-footer-fixed">
    <button
        type="button"
        class="btn btn-default"
        (click)="cancel()">
        Cancel
    </button>
    <button
        id="SaveChanges"
        class="btn btn-primary"
        (click)="save()"
        [disabled]="isSubmitting() || isAsyncValidatorRunning()">
        @if (isSubmitting()) {
            <span class="spinner-border spinner-border-sm"></span>
        }
        <span class="ladda-label">Save Changes</span>
    </button>
</div>
